export default __webpack_public_path__ + "static/media/IMG-20210701-WA0042.8b876b71.jpg";